import { render, staticRenderFns } from "./IconZxwk.vue?vue&type=template&id=06687165"
import script from "./IconZxwk.vue?vue&type=script&lang=js"
export * from "./IconZxwk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports